import axios from 'axios';
import store from "@/domain/vuex/store";
import EVENT_BUS from "@/domain/event-bus/eventBus";


const Http = axios.create({
    baseURL: ('' + process.env.VUE_APP_ROOT_API != 'null')? process.env.VUE_APP_ROOT_API : 'https://api.lity.com.br/',
    timeout: 0,
    headers: { 'Content-Type': 'application/json' }
});

Http.interceptors.request.use( config => {
        if( !!store.state.authenticateStore.token ) {
            config.headers.Authorization =  `Bearer ${store.state.authenticateStore.token}`
        }
        return config
    }, error => Promise.reject(error)
);

Http.interceptors.response.use( response => {
    return response;
    
  }, (error) => {
      if( error.response == undefined || [502, 503].includes(error.response.status) ) {
        const notificationObject = {
          message: 'Desculpe, o servidor está indisponível no momento.',
          type: 'error'
        }
        EVENT_BUS.$emit('ToastNotification', notificationObject)
        return Promise.reject(null);

      } else if( error.response.status == 401 ) {
        if( !!store.state.authenticateStore.token ) {
            const notificationObject = {
              message: 'Desculpe, sua sessão expirou.',
              type: 'error'
            }
            EVENT_BUS.$emit('ToastNotification', notificationObject)
            store.dispatch("authenticateStore/LOGOUT")
            setTimeout(() => {
                window.location.href = '/login';
              }, 1000);
            return Promise.reject(null);

        } else return Promise.reject(error.response.data)

      } else if( error.response.data.message ) {
          if( error.response.data.message.startsWith("could not execute statement; SQL") ) {
            const notificationObject = {
              message: 'Ocorreu um erro em nosso banco de dados, por favor entre em contato conosco ou tente mais tarde.',
              type: 'error'
            }
            EVENT_BUS.$emit('ToastNotification', notificationObject)
            return Promise.reject(null);
            
          } else {
            return Promise.reject(error.response.data);
          }

      } else {
        return Promise.reject(error.response.data);
      }
    }
);

export default Http